import React from 'react'
import Home from './Components/index'

function App() {
  return (
    <div>
      <Home />
    </div>
  )
}

export default App

